import {useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';
import {updateNotesByTnos} from '../../../actions/utActions';
import {Button, TextField, withStyles} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import {showAlertSnackbar} from '../../../reducers/uiSlice';
import {getCurrentWarehouse} from '../../../utilities/common';
import ReactExport from "react-export-excel";
import {getExceptionByState} from '../../../actions/editOrderActions';
import FullScreenLoading from '../../Common/FullscreenLoading';

const FixedTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: 300,
        marginBottom: 20,
    },
}))(TextField);

const InputTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: 200,
        marginLeft: 5
    },
}))(TextField);

function UpdateDriverNotes(props) {
    const {t} = useTranslation('updateToolbox');
    const dispatch = useDispatch();

    const warehouse = getCurrentWarehouse()['id'];

    const [tnos, setTnos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [orderMemo, setOrderMemo] = useState('');

    const tnoRegex = /^[-+]?(?:[0-9a-zA-Z]+,)*[0-9a-zA-Z]+(?:[0-9a-zA-Z]+)?$/i;

    const handleTnosChange = (event) => {
        setTnos();
        setTnos(event.target.value);
    };
    const handleOrderMemoChange = (event) => {
        setOrderMemo(event.target.value);
    };

    const transferTnos = (tnos) => {
        let newTnos = tnos.split('\n');
        let trimmedSubstrings = newTnos.map(function (newTno) {
            return newTno.trim();
        });
        return trimmedSubstrings.join(",");
    }

    const handleTnos = () => {
        if (tnos.length > 0) {
            const tnosCurr = transferTnos(tnos)
            if (tnosCurr) {
                if (tnoRegex.test(tnosCurr)) {
                    setLoading(true);
                    dispatch(updateNotesByTnos(tnosCurr, orderMemo))
                        .then(() => {
                            dispatch(showAlertSnackbar({message: t('update driver notes successed'), type: 'success'}))
                        })
                        .catch((err) => {
                            dispatch(showAlertSnackbar({
                                message: err.message + JSON.stringify(err.additional),
                                type: 'error'
                            }))
                        })
                        .finally(() => {
                            setLoading(false);
                        })
                } else {
                    dispatch(showAlertSnackbar({message: t('format_warning_message'), type: 'warning'}))
                }
            }
        } else {
            dispatch(showAlertSnackbar({message: t('empty_warning_message'), type: 'warning'}))
        }
    }

    return (
        <>
            <div
                style={{
                    display: 'flex'
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 20
                    }}
                >
                    <FixedTextField
                        variant='outlined'
                        label={t('tnos')}
                        placeholder={t('input_parcel_no')}
                        id="updatedrivernotes_tnos_textfield"
                        multiline
                        rows={6}
                        onChange={handleTnosChange}
                    />
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'top',
                        marginLeft: 20
                    }}
                >
                    <FixedTextField
                        variant='outlined'
                        placeholder={t('input_order_memo')}
                        label={t('order_memo')}
                        id="updatedrivernotes_ordermemo_textfield"
                        multiline
                        rows={6}
                        onChange={handleOrderMemoChange}
                    />
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 20
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        id="updatedrivernotes_confirm_button"
                        style={{marginLeft: 10}}
                        onClick={handleTnos}
                        disabled={!orderMemo || !tnos}
                    >
                        {t('confirm_lot_update')}
                    </Button>
                </div>
            </div>
            <FullScreenLoading open={loading}/>
        </>
    );
}

export default UpdateDriverNotes;